import styled from 'styled-components'

const FeaturesList = styled.ul`
  padding: 0 0 0 15px;

  li {
    margin: 0 0 1.3em;
    line-height: 1.5;

    &:last-child {
      margin: 0;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 0;
  }
`

export default FeaturesList
